import noop from 'lodash/noop';
import RxSocket from '@Services/RxSocket';
import SocketBroker from '@Services/SocketBroker';

// eslint-disable-next-line import/prefer-default-export
export const RxSocketRequest = (params) => {
  let off = noop;

  return new Promise((resolve, reject) => {
    if (params.out) {
      off = SocketBroker.observe(params.out, (data) => {
        const isNecessaryResponce = params.filter ? params.filter(data) : true;
        if (isNecessaryResponce) {
          resolve(data);
          off();
        }
      });
    }

    if (params.in) {
      RxSocket.send(params.in, params.data);
      if (!params.out) resolve();
    }

    if (params.maxWaitTime) {
      setTimeout(() => {
        reject(new Error('TIMEOUT'));
        off();
      }, params.maxWaitTime);
    }
  });
};
